import { api } from './cliente.js';

export type CategoriaRaid = 'Risk' | 'Assumption' | 'Issue' | 'Dependency';
export type EstadoRaid = 'Aberto' | 'EmTratamento' | 'Escalado' | 'Mitigado' | 'Fechado';
export type ContextoTipo = 'projeto' | 'programa';

export interface ItemRaid {
  id: string;
  categoria: CategoriaRaid;
  descricao: string;
  responsavel: string;
  prazo: string;
  contextoTipo: ContextoTipo;
  contextoId: string;
  estado: EstadoRaid;
  resultadoFechamento: string | null;
  probabilidade: number | null;
  impacto: number | null;
  severidadeResidual: number | null;
  planoResposta: string | null;
  dataValidacao: string | null;
  validada: boolean | null;
  acaoCorretiva: string | null;
  origemId: string | null;
  dependenciaId: string | null;
  internaExterna: string | null;
  criadoPor: string;
  criadoEm: string;
}

export interface CriarItemRaidInput {
  categoria: CategoriaRaid;
  descricao: string;
  responsavel: string;
  prazo: string;
  contextoTipo: ContextoTipo;
  contextoId: string;
  probabilidade?: 1 | 2 | 3 | 4 | 5;
  impacto?: 1 | 2 | 3 | 4 | 5;
  planoResposta?: 'Mitigar' | 'Transferir' | 'Aceitar' | 'Evitar';
  dataValidacao?: string;
  dependenciaId?: string;
  internaExterna?: 'interna' | 'externa';
}

export const raidApi = {
  listarPorContexto: (contextoTipo: ContextoTipo, contextoId: string) => api.get<ItemRaid[]>(`/raid?contextoTipo=${contextoTipo}&contextoId=${contextoId}`),
  escalacoesAtivas: () => api.get<ItemRaid[]>('/raid/escalacoes'),
  criar: (input: CriarItemRaidInput) => api.post<{ id: string }>('/raid', input),
  transicionar: (id: string, evento: string) => api.post(`/raid/${id}/transicoes`, { evento }),
};
